import React from 'react';
import PropTypes from 'prop-types';

import BaseSkeleton from 'components/Skeleton/BaseSkeleton';
import {
  FiltersRow,
  PageWrapper,
  TableBody,
  TableCard,
  TableHeader,
  TableRow
} from './styled';

export default function ListSkeleton({ rows }) {
  return (
    <PageWrapper>
      <FiltersRow>
        <BaseSkeleton height={44} width={220} />
        <BaseSkeleton height={44} width={180} />
      </FiltersRow>

      <TableCard>
        <TableHeader>
          <BaseSkeleton height={18} width="20%" />
          <BaseSkeleton height={18} width="12%" />
          <BaseSkeleton height={18} width="18%" />
          <BaseSkeleton height={18} width="14%" />
        </TableHeader>

        <TableBody>
          {Array.from({ length: rows }).map((_, index) => (
            <TableRow key={index}>
              <BaseSkeleton height={16} width="88%" />
              <BaseSkeleton height={16} width="72%" />
              <BaseSkeleton height={16} width="76%" />
              <BaseSkeleton height={16} width="58%" />
            </TableRow>
          ))}
        </TableBody>
      </TableCard>
    </PageWrapper>
  );
}

ListSkeleton.propTypes = {
  rows: PropTypes.number,
};

ListSkeleton.defaultProps = {
  rows: 6,
};
